import Vue from 'vue';
import VisibilityService from '../../services/VisibilityService';

declare module 'vue/types/vue' {
    interface Vue {
        rect: DOMRect;
    }
}

const pageOverlay = Vue.component('fl-page-overlay', {
    template: `
          <div @click="closeModal" v-if="showOverlay" class="fl-as-modal-overlay">
          <div class="fl-as-left-overlay" :style="left"></div>
          <div class="fl-as-top-overlay" :style="top"></div>
          <div class="fl-as-right-overlay" :style="right"></div>
          <div class="fl-as-bottom-overlay" :style="bottom"></div>
          </div>`,
    inject: ['config', 'HandleShopInteractionService'],
    props: ['pageOverlayElement'],
    data(): Record<string, any> {
        return {
            rect: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            },
        };
    },
    mounted(): void {
        this.HandleShopInteractionService.onInputTriggered((input: HTMLInputElement) => {
            const usedElement = this.getElementToOverlay(input);
            this.$data.rect = usedElement?.getBoundingClientRect() || {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            };
        });
    },
    methods: {
        closeModal(): void {
            VisibilityService.hide();
        },
        getElementToOverlay(input: HTMLInputElement): HTMLInputElement {
            let usedElement;

            if (this.config.assistedSuggest.config.pageOverlaySelector) {
                const elements = document.querySelectorAll(this.config.assistedSuggest.config.pageOverlaySelector);

                if (elements.length > 1) {
                    const index = this.HandleShopInteractionService.getIndexOfInputElement(input);
                    usedElement = elements.item(index) || input;
                } else {
                    usedElement = elements.item(0) || input;
                }
            }

            return usedElement instanceof Object && typeof usedElement.getBoundingClientRect === 'function' ? usedElement : input;
        },
    },
    computed: {
        showOverlay(): boolean {
            return this.config.assistedSuggest.config?.usePageOverlay;
        },
        right(): { left: string } {
            return {
                left: `${this.rect.right}px`,
            };
        },
        bottom(): { top: string; left: string; width: string } {
            return {
                top: `${this.HandleShopInteractionService.calculateTopPositionFromPositionContext(this.rect.bottom)}px`,
                left: `${this.rect.left}px`,
                width: `${this.rect.width}px`,
            };
        },
        top(): { left: string; width: string; height: string } {
            return {
                left: `${this.rect.left}px`,
                width: `${this.rect.width}px`,
                height: `${this.HandleShopInteractionService.calculateTopPositionFromPositionContext(this.rect.top)}px`,
            };
        },
        left(): { width: string } {
            return {
                width: `${this.rect.left}px`,
            };
        },
    },
});

export default pageOverlay;
